import { createHorizontalSmallHeadingAndTextStyles } from "@guestsupply/App/SharedStyles/smallHeadingAndTextStyles";
import { checkoutReviewAndSubmitPaymentDetailsStyles } from "@guestsupply/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPaymentDetails";
import InfoAlert from "@guestsupply/XDL/Icons/InfoAlert";
import { createLinkIconStyles } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

checkoutReviewAndSubmitPaymentDetailsStyles.paymentMethodAndPONumberContainer = {
    gap: 16,
};

checkoutReviewAndSubmitPaymentDetailsStyles.paymentMethodGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
};
checkoutReviewAndSubmitPaymentDetailsStyles.poNumberGridItem = {
    width: [12, 12, 6, 6, 6],
};
checkoutReviewAndSubmitPaymentDetailsStyles.emptyGridItem = {
    width: [12, 12, 4, 4, 4],
};
checkoutReviewAndSubmitPaymentDetailsStyles.vatNumberGridItem = {
    width: [12, 12, 6, 6, 6],
};
checkoutReviewAndSubmitPaymentDetailsStyles.creditCardDetailsGridItem = {
    width: [12, 12, 6, 6, 6],
};
checkoutReviewAndSubmitPaymentDetailsStyles.creditCardAddressGridItem = {
    width: [12, 12, 6, 6, 6],
};
checkoutReviewAndSubmitPaymentDetailsStyles.paymentMethodSelect = {
    cssOverrides: {
        formInputWrapper: css`
            margin-top: 10px !important;
        `,
    },
};
checkoutReviewAndSubmitPaymentDetailsStyles.tooltipStyle = {};
checkoutReviewAndSubmitPaymentDetailsStyles.paymentDetailsHeading = {
    variant: "h4",
    as: "p",
    css: css`
        margin-bottom: 16px;
    `,
};
checkoutReviewAndSubmitPaymentDetailsStyles.mutliplePoHint = {
    ...createLinkIconStyles(InfoAlert, {
        typographyProps: {
            size: 12,
            weight: "bold",
            css: css`
                margin-left: 2px;
                line-height: 12px;
            `,
        },
        icon: {
            iconProps: {
                size: 12,
                color: "text.link",
            },
            position: "right",
        },
        css: css`
            &&& {
                display: flex;
                margin-left: 8px;
                margin-bottom: 4px;
            }
        `,
    }),
};

checkoutReviewAndSubmitPaymentDetailsStyles.poNumberSmallHeadingAndText = {
    ...createHorizontalSmallHeadingAndTextStyles({
        wrapper: {
            css: css`
                align-items: center;
                margin-bottom: 12px;
            `,
        },
        heading: {
            size: 14,
            weight: "bold",
            css: css`
                letter-spacing: 0;
                line-height: 16px;
            `,
        },
        text: {
            size: 14,
            css: css`
                letter-spacing: 0;
                line-height: 21px;
            `,
        },
    }),
};

checkoutReviewAndSubmitPaymentDetailsStyles.dividerGridItem = {
    width: 12,
    css: css`
        padding: 0;
    `,
};
